const consumptionCCEE = () => import('./consumptionCCEEPage.vue');

export default [
  {
    path: '/consumption-ccee/consumptionCCEE',
    name: 'consumptionCCEE',
    component: consumptionCCEE
  }
];
